/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { SortType } from '../../../utils/sort';
import SortButton from '@features/survey-settings-toolbar/SortButton';
import { CardGridViewModeButtons } from './CardGridViewModeButtons';
import { ViewQuestionsDropdown } from './ViewQuestionsDropdown';
import '../styles.scss';

interface CustomMetricsDashboardProps {
  children?: JSX.Element | JSX.Element[];
  viewQuestionsLabel?: string;
  currentSort: SortType;
  handleSort: (code: SortType) => void;
}

export function CustomMetricsDashboardToolbar(props: CustomMetricsDashboardProps) {
  const { viewQuestionsLabel = 'Filter by', currentSort, handleSort } = props;

  return (
    <div className='survey-settings-toolbar-container'>
      <div className='survey-settings-toolbar d-flex justify-content-end align-items-center'>
        <div className='mr-2'>{viewQuestionsLabel}</div>
        <div className='mr-auto'>
          <ViewQuestionsDropdown />
        </div>
        {props.children}
        <div>
          <CardGridViewModeButtons />
        </div>
        <span className='ml-2'>
          <SortButton currentSort={currentSort} handleSort={handleSort} />
        </span>
      </div>
    </div>
  );
}
